var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VTable',{attrs:{"items":_vm.items,"headers":_vm.headers,"total":0,"loading":_vm.$isLoading('loyaltyPrograms'),"pagination":false,"editable":false},on:{"page":function($event){return _vm.$emit('page', $event)},"edited":function($event){return _vm.$emit('edited', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }